import { useState } from "react";
import { Col, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import LoadingButton from "../../components/Loading/LoadingButton";
import usePDFDownload from "../../hooks/usePDFDownload";

export default function PreOrderCodePrint({ selected }) {
  const [type, setType] = useState(1);
  const { mutate, isPending } = usePDFDownload({
    body: { type, ids: selected },
    url: "/totalpost/v1/preOrderCode/print",
  });

  const print = () => {
    if (selected.length < 1) {
      Swal.fire({
        icon: "warning",
        text: "هیچ موردی انتخاب نشده است",
        confirmButtonText: "باشه",
      });
      return;
    }

    mutate();
  };

  return (
    <div className="bs py-5">
      <h5>پرینت مرسولات انتخابی از لیست</h5>

      <Col xs={12} sm={6} md={5}>
        <Form.Label>نوع PDF درخواستی</Form.Label>
        <Form.Select onChange={e => setType(e.target.value)} value={type}>
          <option value="1">یک فایل و هر صفحه یک جفت کد پیش سفارش افقی</option>
          <option value="2">یک فایل و هر صفحه یک جفت کد پیش سفارش عمودی</option>
        </Form.Select>
      </Col>

      <Col xs={12} className="pt-3">
        <LoadingButton
          center
          className="btn-outline-success"
          isLoading={isPending}
          onClick={print}
          title={isPending ? "در حال دریافت" : "پرینت"}
        />
      </Col>
    </div>
  );
}
